module.exports = __webpack_public_path__ + "static/media/Societe-Direction-Travaux-immobilier-Vaud.37b5c2d7.jpg";